import { useCallback } from 'react';
import { useConfigurationSectionRoutePrefixHook } from './useConfigurationSectionRoutePrefix.hook';

export interface UseOpenSmartFieldDetailPageReturn {
  readonly openSmartFieldDetailPage: (smartFieldId: string) => void;
}

export function useOpenSmartFieldDetailPage(): UseOpenSmartFieldDetailPageReturn {
  const configurationRoutePrefix = useConfigurationSectionRoutePrefixHook();

  const openSmartFieldDetailPage = useCallback(
    (smartFieldId: string) => {
      if (smartFieldId) {
        window.open(`${configurationRoutePrefix}/smart-fields/${smartFieldId}`, '_blank', 'noopener,noreferrer');
      }
    },
    [configurationRoutePrefix],
  );

  return { openSmartFieldDetailPage };
}
